/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from "react";
import { API_BASE } from "../../AppConfig";
import { fetchTimeout } from "../../components/Common";

export const InitaliseLoad = ({ intialise, setBusinessList, setLoading, setIntialise }) => {
    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "business/";
            fetchTimeout(api_url, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((json) => {
                    
                    setBusinessList(json);
                    setLoading(false);
                    setIntialise(true);
                })
                .catch((e) => {
                    
                    setBusinessList([]);
                });
        }
    }, [intialise]);
};

export const InitaliseBusiness = ({
    intialise,
    setNull,
    BusinessDetails,
    validationSchema,
    checkJobStateValidationSchema,
    setErrorState,
    props,
    setIntialise,
}) => {
    React.useEffect(() => {
        if (!intialise) {
            let newErrorState = setNull(BusinessDetails);
            for (let param in BusinessDetails) {
                if (validationSchema?.Distributor?.[param] && param === "id") {
                    let error = "";
                    error = checkJobStateValidationSchema(
                        validationSchema,
                        "Distributor",
                        null,
                        param,
                        BusinessDetails[param]
                    );
                    newErrorState[param] = error;
                }
            }
            setErrorState({ state: newErrorState, props });
            
            setIntialise(true);
        }
    }, [intialise]);
};

export const validateProgressPaymentPercentages = ({ disableSaveButton, paymentStructure }) => {
    useEffect(() => {
        const deposit = parseFloat(paymentStructure.SupplyOnlyDeposit);
        if (isNaN(deposit) || deposit < 0 || deposit > 100) {
            disableSaveButton(true);
        } else {
            disableSaveButton(false);
        }
    }, [paymentStructure.SupplyOnlyDeposit]);
};